export interface MissionStatementFormProps {
  // Outputs
  mode: 'add' | 'edit';
  formState: MissionStatementFormState;
  isLoading: boolean;
  // Inputs
  userUpdatedFormState: React.Dispatch<React.SetStateAction<MissionStatementFormState>>;
  userClickedCancel: () => void;
  /**
   * Called when the user clicks the "Add Section" button
   * to indicate that they want to add a new section to the mission statement
   **/
  userClickedSaveSection: () => void;
}

export interface MissionStatementFormState {
  markdown: string;
  thumbnail: File | null;
  thunbnailUrl?: string | null;
}

export const missionStatementInitialFormState: MissionStatementFormState = {
  markdown: '',
  thumbnail: null,
  thunbnailUrl: null,
};
